module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_MT-5077f8a563728b6bb858ee7a588c4527.svg";